import React, { useMemo } from 'react';
import { RouterProvider, Navigate, createBrowserRouter, redirect } from 'react-router-dom';

import { useAuth, authenticationRouter } from './features/authentication';
import { chatsRouter } from './features/chats';
import { onboardingRouter } from './features/onboarding';
import { useOrganizations, organizationRouter, useUsers } from './features/organization';

const AppRouter = () => {
  const auth = useAuth();
  const { organizations, currentOrganization, selectOrganization } = useOrganizations();
  const { invitations } = useUsers();

  const router = useMemo(
    () =>
      createBrowserRouter([
        {
          path: '/',
          loader: async ({ request }) => {
            if (auth.isAuthenticated()) {
              const isCreateOrganizationPage = request.url.match(/onboarding\/organization/);
              const isInvitationsPage = request.url.match(/onboarding\/invitations/);

              const noOrganizations = organizations?.length === 0;
              const hasInvitations = Array.isArray(invitations) && invitations?.length > 0;

              if (
                !isCreateOrganizationPage &&
                !isInvitationsPage &&
                noOrganizations &&
                !hasInvitations
              ) {
                return redirect('/onboarding/organization');
              }

              if (!isInvitationsPage && hasInvitations) {
                return redirect('/onboarding/invitations');
              }
            }

            return null;
          },
          children: [
            {
              index: true,
              loader: () => {
                // get the IntendedURL
                const IntendedURL = sessionStorage.getItem('IntendedURL');
                if (IntendedURL) {
                  return redirect(IntendedURL);
                }
                return redirect('/spaces');
              }
            },
            {
              path: '/home',
              element: <Navigate to='/spaces' replace />
            },
            authenticationRouter(),
            onboardingRouter(),
            chatsRouter({
              user: auth.user,
              logout: auth.logout,
              organizations,
              currentOrganization,
              selectOrganization
            }),
            organizationRouter()
          ]
        }
      ]),
    [auth, organizations, invitations, currentOrganization]
  );

  return <RouterProvider router={router} />;
};

export { AppRouter };
